import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=4c09026d&scoped=true"
import script from "./commodity.vue?vue&type=script&lang=ts"
export * from "./commodity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c09026d",
  null
  
)

export default component.exports